import servizioIcon from "../../../../assets/images/icon-big-gestioneutenti-88-px.svg";
import Typography from "@material-ui/core/Typography";
import {Box, Button, Paper} from "@material-ui/core";
import React, {useState} from "react";
import PropTypes from "prop-types";
import {useContactBoxStyles} from "./ContactBoxStyles";

const ContactBox = (props) => {
    const [elevation, setElevation] = useState(5);
    const classes = useContactBoxStyles();

    const handleContattaciDialogToggle = () => {
        props.setOpenContattaciDialog(true);
    }

    return (
        <Paper className={classes.root} elevation={elevation}
               onMouseEnter={() => setElevation(15)}
               onMouseLeave={() => setElevation(5)}>

            <Box className={classes.divWrapper}>
                <img className={classes.contactIcon} src={servizioIcon}
                     alt="assistance_icon"/>
                <Typography variant="subtitle2">
                    Servizio clienti
                </Typography>
                <p>
                    <Typography className={classes.contactText} variant="caption">
                        Hai bisogno di aiuto? Facci sapere come possiamo aiutarti
                    </Typography>
                </p>
                <Button onClick={handleContattaciDialogToggle}
                        fullWidth
                        disabled={false}
                        color="primary"
                        variant="outlined">Contattaci</Button>
            </Box>
        </Paper>
    )
}

ContactBox.propTypes = {
    setOpenContattaciDialog: PropTypes.func.isRequired
}

export default ContactBox
